import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import styles from './HeaderSearchResult.module.css';
import { Context } from "../../../index";
import { useNavigate } from "react-router";
import { searchTipsBound } from '../../../http/publicSearchApi';
import { SEARCH } from '../../../utils/consts';

const HeaderSearchResult = ({setStateSearcht}) => {
    const {settings} = useContext(Context);
    const [data, setData] = useState([]);
    const [error, setError] = useState(false);
    const [retry, setRetry] = useState(0);
    let navigate = useNavigate();

    const listRef = useRef();
    const requestIdRef = useRef(0);
    const frameRef = useRef(null);
    const query = settings.searchQuery.trim();
    const currentQuery = useRef(query);
    currentQuery.current = query;

    const handleWindowResize = useCallback(() => {
        const search = document.querySelector('.input_search_product');

        if (listRef.current && search) {
            listRef.current.style.marginLeft = `${search.getBoundingClientRect().left}px`;
            listRef.current.style.maxWidth = `${search.getBoundingClientRect().width + 10 + 18}px`;
        }
    }, [])

    useEffect(() => {
        const requestId = ++requestIdRef.current;
        const isCurrent = () => requestId === requestIdRef.current && currentQuery.current === query;
        const cancelFrame = () => {
            if (frameRef.current !== null) window.cancelAnimationFrame(frameRef.current);
            frameRef.current = null;
        };
        cancelFrame();
        setData([]);
        setError(false);
        document.documentElement.style.removeProperty('--search-result-height');
        if (query.length < 2) {
            return () => {if (requestIdRef.current === requestId) requestIdRef.current += 1;};
        }

        const timer = window.setTimeout(async () => {
            try {
                const response = await searchTipsBound(query);
                if (!isCurrent()) return;
                if (!Array.isArray(response) || !response.every(item => item && typeof item.name === 'string')) throw new Error();
                setData(response);
                frameRef.current = window.requestAnimationFrame(() => {
                    if (!isCurrent()) return;
                    frameRef.current = null;
                    handleWindowResize();
                    if (listRef.current) {
                        document.documentElement.style.setProperty(
                            '--search-result-height',
                            `${listRef.current.offsetHeight}px`,
                        );
                    }
                });
            } catch (error) {
                if (!isCurrent()) return;
                setData([]);
                setError(true);
            }
        }, 250);

        return () => {
            if (requestIdRef.current === requestId) requestIdRef.current += 1;
            window.clearTimeout(timer);
            cancelFrame();
            document.documentElement.style.removeProperty('--search-result-height');
        };
    }, [handleWindowResize, query, retry]);

    const onClickResult = (query) => {
        setStateSearcht(false);

        settings.setSearchQuery(query)
        navigate({pathname: SEARCH, search: `?query=${encodeURIComponent(query)}`});
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        }
    }, [handleWindowResize])

    const ucFirst = (str) => {
        if (!str) return str;
        return str[0].toUpperCase() + str.slice(1);
    }

    return (
        <>
            {!!settings.searchQuery && (
                <div className={styles.root}>
                    <ul className={styles.list} ref={listRef}>
                        {!!data.length && data.map((item, i) => (
                            <li className={styles.item} key={item.id || `${i}:${item.name}`} onClick={() => onClickResult(item.name)}>
                                {ucFirst(item.name)}
                            </li>
                        ))}
                    </ul>
                    {error && <div role="alert">
                        Не удалось загрузить подсказки.
                        <button type="button" onClick={() => setRetry(value => value + 1)}>Повторить</button>
                    </div>}
                </div>
            )}
        </>
    );
};

export default HeaderSearchResult;
